import '../index.css';

export default function CTA() {
  return (
    <section className="cta-section">
      <div className="section-inner">
        <div className="cta-box">
          <h2 className="cta-title">Comece a Usar o Lovable Ilimitado nos Proximos 5 Minutos</h2>
          <p className="cta-subtitle">Instale a extensao, ative sua licenca e crie projetos sem limites</p>

          <a
            href="#planos"
            className="cta-button"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('planos')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            &#128640; Quero Acesso Agora
          </a>

          <div className="cta-badges">
            <span>&#128179; Pagamento seguro via PIX ou Cartao</span>
            <span>&#9989; Acesso imediato por email</span>
            <span>&#128737;&#65039; 7 dias de garantia total</span>
          </div>
        </div>
      </div>
    </section>
  );
}
